import StoresContainer from './StoresContainer';

export default StoresContainer;
